/* ============================================================
   Howard Wire — theme.js
   Progressive enhancement: quote-cart count, cart quantity edits,
   contact tabs, product variant URL, and the quote wizard.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Buy cart count in the top bar (real Shopify cart). The QUOTE count is
         owned by the separate localStorage quote lane below (HWQuote). ---- */
  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') { return; }
        document.querySelectorAll('#BuyCartCount, [data-buy-count]').forEach(function (el) { el.textContent = cart.item_count; });
        /* the header cart icon only appears once a buy-now item is in it */
        document.querySelectorAll('.mi-buycart').forEach(function (el) { if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); } });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartCount);
  } else { updateCartCount(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') !== -1) { setTimeout(updateCartCount, 500); }
  });

  /* ---- [data-open-meshy] opens the Meshy chat if the widget loaded; otherwise the link's
         href (contact page) still works, so nothing is ever a dead end. ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-open-meshy]') : null;
    if (!a) return;
    var l = document.querySelector('.hw-launcher, #hw-launcher');
    if (l) { e.preventDefault(); l.click(); }
  });

  /* ---- Cart line quantity edits (quote cart) ---- */
  function rebuildQuoteItems(cart) {
    var hid = document.querySelector('input[name="contact[Quote Items]"]');
    if (hid && cart && cart.items) {
      hid.value = cart.items.map(function (it) {
        return (it.sku || it.product_title) + ' ×' + it.quantity + ' — ' + it.product_title;
      }).join(' // ');
    }
  }
  function changeLine(input, qty) {
    var line = input.getAttribute('data-line');
    if (!line) return;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(); rebuildQuoteItems(cart);
      if (qty === 0) {
        if (cart.item_count === 0) { window.location.reload(); return; }
        var row = input.closest('.cart-row'); if (row) { row.parentNode.removeChild(row); }
      } else { input.value = qty; }
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest && e.target.closest('[data-qty-up], [data-qty-down]');
    if (stepBtn) {
      var wrap = stepBtn.closest('[data-cart-qty]');
      var input = wrap && wrap.querySelector('.qty-input');
      if (input) {
        var v = parseInt(input.value, 10); if (isNaN(v)) { v = 0; }
        v += stepBtn.hasAttribute('data-qty-up') ? 1 : -1; if (v < 0) { v = 0; }
        if (input.hasAttribute('data-line')) { changeLine(input, v); } else { input.value = v; }
      }
      return;
    }
    /* Contact form tabs */
    var tab = e.target.closest && e.target.closest('.tab[data-tab]');
    if (tab) {
      var key = tab.getAttribute('data-tab');
      tab.parentNode.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      document.querySelectorAll('.form-pane[data-pane]').forEach(function (p) {
        p.classList.toggle('active', p.getAttribute('data-pane') === key);
      });
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.classList && input.classList.contains('qty-input') && input.hasAttribute('data-line')) {
      var v = parseInt(input.value, 10); if (isNaN(v) || v < 0) { v = 0; }
      changeLine(input, v);
    }
    /* Product variant → reflect in URL */
    if (input.tagName === 'SELECT' && input.name === 'id' && input.form && input.form.id === 'ProductForm') {
      if (input.value && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url.toString());
      }
    }
  });

  /* ---- Phone fields: US numbers become 510-887-8787 so the form email pastes straight
     into the CRM. Formats while typing only when the caret is at the end (so editing the
     middle doesn't jump the cursor), then again on change and on submit. A leading 1 / +1
     is dropped (no US area code starts with 1). International (+ other than +1),
     extensions ("x12") and anything over 10 digits are left exactly as typed. ---- */
  function formatPhone(raw) {
    var d = raw.replace(/\D/g, '');
    if (/^\s*\+/.test(raw) && d.charAt(0) !== '1') { return raw; }
    if (/[a-z]/i.test(raw)) { return raw; }
    if (d.charAt(0) === '1') { d = d.slice(1); }
    if (d.length > 10) { return raw; }
    if (d.length < 4) { return d; }
    if (d.length < 7) { return d.slice(0, 3) + '-' + d.slice(3); }
    return d.slice(0, 3) + '-' + d.slice(3, 6) + '-' + d.slice(6);
  }
  function setPhone(f) { var p = formatPhone(f.value); if (p !== f.value) { f.value = p; } }
  document.addEventListener('input', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('input[type="tel"]')) return;
    if (f.selectionStart === f.value.length) { setPhone(f); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[type="tel"]')) { setPhone(e.target); }
  });
  document.addEventListener('submit', function (e) {
    e.target.querySelectorAll('input[type="tel"]').forEach(setPhone);
  }, true);

  /* ---- Quote wizard (Cart → Contact → Ship-To → Review) ---- */
  (function () {
    var wizard = document.getElementById('QuoteWizard');
    var form = document.getElementById('QuoteForm');
    if (!wizard || !form) return;
    var panes = form.querySelectorAll('.pane[data-pane]');
    if (!panes.length) return; /* confirmation view has no panes */
    var steps = document.querySelectorAll('.stepper .step[data-step]');
    var progress = document.getElementById('QuoteProgress');
    var total = panes.length, current = 1;

    function fieldByName(n) { return form.querySelector('[name="' + n + '"]'); }

    function populateReview() {
      form.querySelectorAll('[data-review]').forEach(function (el) {
        var name = el.getAttribute('data-review'), val = '';
        var checked = form.querySelector('[name="' + name + '"]:checked');
        if (checked) { val = checked.value; }
        else { var f = fieldByName(name); if (f) { val = f.value; } }
        el.textContent = val || '—';
      });
      var shipto = form.querySelector('[data-review-shipto]');
      if (shipto) {
        function v(n) { var f = fieldByName(n); return f ? f.value.trim() : ''; }
        var parts = [v('contact[Ship Company]'), v('contact[Ship-To Address]')].filter(Boolean);
        shipto.innerHTML = parts.length ? parts.join('<br>') : '—';
      }
    }
    function validate(n) {
      var pane = form.querySelector('.pane[data-pane="' + n + '"]'); if (!pane) return true;
      var ok = true, first = null;
      pane.querySelectorAll('[data-req]').forEach(function (f) {
        var bad = !f.value.trim() || (f.type === 'email' && f.value.indexOf('@') < 1);
        f.style.borderColor = bad ? 'var(--hw-red)' : '';
        if (bad && !first) { first = f; } if (bad) { ok = false; }
      });
      if (first) { first.focus(); }
      return ok;
    }
    function show(n) {
      current = Math.max(1, Math.min(total, n));
      panes.forEach(function (p) { p.classList.toggle('active', parseInt(p.getAttribute('data-pane'), 10) === current); });
      steps.forEach(function (s) {
        var sn = parseInt(s.getAttribute('data-step'), 10);
        s.classList.toggle('active', sn === current);
        s.classList.toggle('done', sn < current);
      });
      if (progress) { progress.style.width = ((current - 1) / (total - 1) * 75) + '%'; }
      if (current === total) { populateReview(); }
      var anchor = document.querySelector('.stepper') || wizard;
      window.scrollTo({ top: anchor.offsetTop - 16, behavior: 'smooth' });
    }

    wizard.addEventListener('click', function (e) {
      if (e.target.closest('[data-next]')) { if (validate(current)) { show(current + 1); } }
      else if (e.target.closest('[data-prev]')) { show(current - 1); }
      else if (e.target.closest('[data-goto]')) { show(parseInt(e.target.closest('[data-goto]').getAttribute('data-goto'), 10)); }
      else {
        var card = e.target.closest('.radio-card');
        if (card) {
          card.parentNode.querySelectorAll('.radio-card').forEach(function (c) { c.classList.remove('checked'); });
          card.classList.add('checked');
          var r = card.querySelector('input[type=radio]'); if (r) { r.checked = true; }
        }
      }
    });
    steps.forEach(function (s) {
      s.style.cursor = 'pointer';
      s.addEventListener('click', function () {
        var n = parseInt(s.getAttribute('data-step'), 10);
        if (n <= current) { show(n); } else if (validate(current)) { show(current + 1); }
      });
    });

    /* Enter implicitly submits a form from any field. Without this the wizard could post
       from step 2 with the later panes never filled in — and validate() only ever ran on
       the Next button, not on submit. Advance instead of submitting, unless we are on the
       final pane and every earlier pane passes. */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.shiftKey) return;
      var t = e.target;
      if (t && (t.tagName === 'TEXTAREA' || t.type === 'submit' || t.type === 'button')) return;
      if (current < total) {
        e.preventDefault();
        if (validate(current)) { show(current + 1); }
      }
    });
    form.addEventListener('submit', function (e) {
      for (var i = 1; i <= total; i++) {
        if (!validate(i)) { e.preventDefault(); show(i); return; }
      }
    });

    show(1);
  })();
})();

/* ============================================================
   Predictive search — search-as-you-type on any search box
   (catalog filter bar + /search page). Uses Shopify's suggest API.
   ============================================================ */
(function () {
  'use strict';
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
  var inputs = document.querySelectorAll('input[type="search"][name="q"]');
  Array.prototype.forEach.call(inputs, function (input) {
    var parent = input.parentElement || input;
    if (getComputedStyle(parent).position === 'static') { parent.style.position = 'relative'; }
    var box = document.createElement('div');
    box.className = 'psearch-results';
    box.setAttribute('hidden', '');
    parent.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    var timer;
    function close() { box.setAttribute('hidden', ''); box.innerHTML = ''; }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=7', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (((data || {}).resources || {}).results || {}).products || [];
            var html = '';
            products.forEach(function (p) {
              var sub = p.product_type || p.vendor || '';
              html += '<a class="psearch-item" href="' + p.url + '">' +
                        '<span class="psearch-title">' + esc(p.title) + '</span>' +
                        (sub ? '<span class="psearch-sub">' + esc(sub) + '</span>' : '') +
                      '</a>';
            });
            html += '<a class="psearch-all" href="/search?q=' + encodeURIComponent(q) + '">' +
                      (products.length ? 'See all results for "' + esc(q) + '" →' : 'No matches — search the full catalog →') +
                    '</a>';
            box.innerHTML = html;
            box.removeAttribute('hidden');
          })
          .catch(function () { close(); });
      }, 200);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
    document.addEventListener('click', function (e) { if (!box.contains(e.target) && e.target !== input) { close(); } });
  });
})();

/* ============================================================
   Quote lane — a SEPARATE quote cart stored in the browser
   (localStorage), independent of the real Shopify (buy) cart.
   "Add to Quote" buttons add here; the /pages/quote wizard reads
   here and emails it. The Shopify cart is reserved for buyable
   ("for-sale") items + real checkout.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'hw_quote_v1';
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
  /* esc() leaves quotes intact, which is fine for a text node but breaks an attribute the
     moment someone types an inch mark — and the dimension fields below invite exactly that. */
  function attr(s) { return esc(s).replace(/"/g, '&quot;'); }
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(items, quiet) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    /* quiet: storage + the hidden fields only. A full sync() re-renders #QuoteList, which
       would destroy the input the visitor is currently typing a cut size into. */
    if (quiet) { syncQuiet(); } else { sync(); }
  }
  function count() { return read().reduce(function (n, i) { return n + (i.qty || 1); }, 0); }
  function add(it) {
    var items = read(), found = null, i;
    for (i = 0; i < items.length; i++) { if (items[i].key === it.key) { found = items[i]; break; } }
    if (found) { found.qty += it.qty; } else { items.push(it); }
    write(items);
  }
  function remove(key) { write(read().filter(function (i) { return i.key !== key; })); }
  function setQty(key, qty) { read(); var items = read(); items.forEach(function (i) { if (i.key === key) { i.qty = Math.max(1, qty); } }); write(items); }
  /* Cut dimensions are captured here on the quote page rather than on the product page,
     because add() merges lines on variant id alone — two cut sizes of the same variant would
     silently collapse into one. Setting them per stored line avoids that entirely. */
  function setField(key, name, value) {
    var items = read();
    items.forEach(function (i) { if (i.key === key) { i[name] = value; } });
    write(items, true);
  }
  function clear() { write([]); }
  window.HWQuote = { read: read, add: add, remove: remove, setQty: setQty, setField: setField, clear: clear, count: count };

  /* ---- "Add to Quote" intercept (product page) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-add-to-quote]') : null;
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form'), id = '', qty = 1, title = btn.getAttribute('data-title') || '', url = btn.getAttribute('data-url') || '', variant = '', sku = '', img = '';
    if (form) {
      var idEl = form.querySelector('[name="id"]'); if (idEl) id = idEl.value;
      var qEl = form.querySelector('[name="quantity"]'); if (qEl) qty = Math.max(1, parseInt(qEl.value || '1', 10) || 1);
    }
    var pj = document.querySelector('[data-product-json]'), product = null;
    try { if (pj) product = JSON.parse(pj.textContent); } catch (er) {}
    if (product) {
      title = product.title || title; url = product.url || url;
      var v = null, k;
      for (k = 0; k < (product.variants || []).length; k++) { if (String(product.variants[k].id) === String(id)) { v = product.variants[k]; break; } }
      if (!v && product.variants) { v = product.variants[0]; }
      if (v) {
        id = v.id; sku = v.sku || '';
        if (v.title && v.title !== 'Default Title') { variant = v.title; }
        img = (v.featured_image && v.featured_image.src) || '';
      }
      if (!img) { img = (typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image && product.featured_image.src)) || (product.images && product.images[0]) || ''; }
    }
    if (!id) { return; }
    add({ key: String(id), id: String(id), title: title, variant: variant, sku: sku, url: url, image: img, qty: qty });
    var orig = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', orig); btn.textContent = 'Added to Quote ✓'; btn.classList.add('added');
    setTimeout(function () { btn.textContent = orig; btn.classList.remove('added'); }, 1600);
    toast(title + (variant ? ' — ' + variant : ''));
  });

  /* ---- "Added" confirmation. The button flash alone was easy to miss, and the header
         count is often scrolled out of view, so people couldn't tell the click worked. ---- */
  var toastTimer = null;
  function toast(label) {
    var el = document.getElementById('HWQuoteToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'HWQuoteToast'; el.className = 'hwq-toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
      el.addEventListener('click', function (e) { if (e.target.closest('[data-toast-close]')) { e.preventDefault(); el.classList.remove('show'); } });
    }
    var n = count();
    el.innerHTML = '<span class="hwq-toast-check" aria-hidden="true">✓</span>' +
      '<div class="hwq-toast-txt"><strong>Added to your quote list</strong><span>' + esc(label) + '</span></div>' +
      '<div class="hwq-toast-acts"><a class="hwq-toast-go" href="/pages/quote">View quote list (' + n + ') →</a>' +
      '<a class="hwq-toast-more" href="#" data-toast-close>Keep browsing</a></div>' +
      '<button type="button" class="hwq-toast-x" data-toast-close aria-label="Close">✕</button>';
    el.classList.add('show');
    document.querySelectorAll('.mi-quote').forEach(function (q) { q.classList.remove('bump'); void q.offsetWidth; q.classList.add('bump'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 7000);
  }

  /* ---- Quote page render ---- */
  /* One place that decides how a cut size reads, so the row, the review step and the
     email that sales receives can never drift apart. */
  function dimText(it) {
    var l = (it.len || '').toString().trim(), w = (it.wid || '').toString().trim(), p = (it.pcs || '').toString().trim();
    if (!l && !w && !p) { return ''; }
    var size = (l && w) ? (l + ' × ' + w) : (l || w);
    return size + (p ? (size ? ', ' : '') + p + ' pc' : '');
  }
  function renderPage(root) {
    if (root.querySelector('.confirm.active')) { return; } // post-submit confirmation
    var items = read(), empty = root.querySelector('#QuoteEmpty'), flow = root.querySelector('#QuoteFlow');
    var spec = root.querySelector('#QuoteSpecBlock'), isEmpty = !items.length;
    /* The request form is ALWAYS usable. Hiding the whole wizard on an empty cart made every
       cold arrival — hero CTA, 404 page, a search for "howard wire quote" — a dead end. */
    if (empty) empty.hidden = true;
    if (flow) flow.hidden = false;
    if (spec) spec.hidden = !isEmpty;
    var n = count();
    root.querySelectorAll('[data-quote-itemcount]').forEach(function (el) {
      el.textContent = isEmpty ? 'Specs below' : (n + ' item' + (n !== 1 ? 's' : ''));
    });
    var list = root.querySelector('#QuoteList');
    if (list) {
      list.innerHTML = items.map(function (it) {
        return '<div class="cart-row" data-key="' + esc(it.key) + '">' +
          '<a class="cart-thumb" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(it.image) + '" width="80" height="80" alt="' + esc(it.title) + '">' : '') + '</a>' +
          '<div class="cart-info">' + (it.sku ? '<div class="cart-sku">SKU · ' + esc(it.sku) + '</div>' : '') +
            '<div class="cart-title"><a href="' + esc(it.url) + '">' + esc(it.title) + '</a></div>' +
            (it.variant ? '<div class="cart-specs">' + esc(it.variant) + '</div>' : '') + '</div>' +
          '<div><span class="cart-qty-lbl mono">Full rolls / sheets</span><div class="cart-controls"><button type="button" class="qty-btn" data-q-down aria-label="Decrease">−</button>' +
            '<input class="qty-input" type="number" min="1" value="' + (it.qty || 1) + '" data-q-input aria-label="Quantity">' +
            '<button type="button" class="qty-btn" data-q-up aria-label="Increase">+</button></div></div>' +
          '<a class="cart-remove" href="#" data-q-remove title="Remove" aria-label="Remove ' + attr(it.title) + '">✕</a>' +
          '<div class="cart-dims"><span class="cart-dims-lbl mono">Or cut pieces</span>' +
            '<input class="dim-in" type="text" value="' + attr(it.len || '') + '" data-dim="len" placeholder="Length, e.g. 24 in" aria-label="Cut length for ' + attr(it.title) + '">' +
            '<span class="dim-x" aria-hidden="true">×</span>' +
            '<input class="dim-in" type="text" value="' + attr(it.wid || '') + '" data-dim="wid" placeholder="Width, e.g. 36 in" aria-label="Cut width for ' + attr(it.title) + '">' +
            '<input class="dim-in dim-pcs" type="text" value="' + attr(it.pcs || '') + '" data-dim="pcs" placeholder="How many" aria-label="Number of cut pieces for ' + attr(it.title) + '">' +
            '<span class="cart-dims-hint">Leave blank if you want full rolls or sheets. Inches or feet — just write which.</span>' +
          '</div></div>';
      }).join('');
    }
    fillFields(root, items, isEmpty, n);
  }

  /* The hidden fields sales actually reads, plus the review mirror. Kept separate from the
     row rendering so a dimension edit can refresh them without rebuilding the list. */
  function fillFields(root, items, isEmpty, n) {
    var rev = root.querySelector('#QuoteReviewList');
    if (rev && !isEmpty) {
      rev.innerHTML = items.map(function (it) {
        return '<div class="review-cart-row"><div class="review-cart-thumb">' + (it.image ? '<img src="' + attr(it.image) + '" width="44" height="44" alt="">' : '') + '</div>' +
          '<div class="review-cart-mid"><div class="review-cart-sku">' + esc(it.sku || 'ITEM') + '</div><div class="review-cart-title">' + esc(it.title) + '</div>' +
            (dimText(it) ? '<div class="review-cart-dims">Cut ' + esc(dimText(it)) + '</div>' : '') + '</div>' +
          '<div class="review-cart-qty">' + (it.qty || 1) + '</div></div>';
      }).join('');
    }
    var field = root.querySelector('#QuoteItemsField');
    if (field) {
      field.value = isEmpty
        ? 'No catalog items — see the Requested Specs fields'
        : items.map(function (it) {
            var q = it.qty; if (!q || q < 1) { q = 1; }
            var d = dimText(it);
            return q + '× ' + (it.sku || it.title) + ' - ' + it.title +
                   (it.variant ? ' (' + it.variant + ')' : '') + (d ? ' — CUT ' + d : '');
          }).join(' // ');
    }
    /* Quantity as its own line in the quote email. One item → just the number;
       several → the total plus a per-SKU breakdown, so it stays readable. */
    var qtyField = root.querySelector('#QuoteQtyField');
    if (qtyField) {
      var parts = items.map(function (it) {
        var q = it.qty; if (!q || q < 1) { q = 1; }
        return q + ' × ' + (it.sku || it.title);
      });
      qtyField.value = isEmpty ? '— (no catalog items)'
        : (items.length === 1 ? String(n) : (n + ' total — ' + parts.join(', ')));
    }
  }

  /* ---- qty / remove on the quote page ---- */
  document.addEventListener('click', function (e) {
    var row = e.target.closest ? e.target.closest('.cart-row[data-key]') : null;
    if (!row) return;
    var key = row.getAttribute('data-key'), inp = row.querySelector('[data-q-input]'), cur = inp ? (parseInt(inp.value, 10) || 1) : 1;
    if (e.target.closest('[data-q-remove]')) { e.preventDefault(); remove(key); }
    else if (e.target.closest('[data-q-up]')) { setQty(key, cur + 1); }
    else if (e.target.closest('[data-q-down]')) { setQty(key, cur - 1); }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    var inp = e.target.closest('.cart-row[data-key] [data-q-input]');
    if (inp) {
      var row = inp.closest('.cart-row[data-key]'); setQty(row.getAttribute('data-key'), parseInt(inp.value, 10) || 1);
      return;
    }
    var dim = e.target.closest('.cart-row[data-key] [data-dim]');
    if (dim) {
      var r = dim.closest('.cart-row[data-key]');
      setField(r.getAttribute('data-key'), dim.getAttribute('data-dim'), dim.value.trim());
    }
  });

  /* ---- keep the hidden email field current right before submit ---- */
  var qf = document.getElementById('QuoteForm');
  if (qf) { qf.addEventListener('submit', function () {
    var root = document.querySelector('[data-quote-cart]'); if (root) renderPage(root);
    /* the reference number must exist BEFORE the post so it reaches the quote email */
    /* Date-stamped reference. The previous form was the year plus 4 random digits, which
       collides: across a few hundred quotes a year, two customers are near-certain to be
       handed the same number. Including the date narrows a collision to two quotes on the
       SAME day drawing the same 4 digits. */
    var now = new Date();
    var p2 = function (v) { return v < 10 ? '0' + v : String(v); };
    var ref = '#HW-' + now.getFullYear() + p2(now.getMonth() + 1) + p2(now.getDate()) + '-' + Math.floor(1000 + Math.random() * 9000);
    var rf = document.getElementById('QuoteRefField'); if (rf) { rf.value = ref; }
    try { localStorage.setItem('hw_quote_ref', ref); } catch (x) {}
  }); }

  /* ---- sync header count + quote page ---- */
  function syncQuiet() {
    var root = document.querySelector('[data-quote-cart]');
    if (!root || root.querySelector('.confirm.active')) { return; }
    var items = read();
    fillFields(root, items, !items.length, count());
  }
  function sync() {
    var n = count();
    document.querySelectorAll('#QuoteCartCount, [data-quote-count]').forEach(function (el) { el.textContent = n; });
    var root = document.querySelector('[data-quote-cart]'); if (root) renderPage(root);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sync); } else { sync(); }

  /* ---- clear the quote list after a successful submit (confirmation shown) ---- */
  if (document.querySelector('[data-quote-cart] .confirm.active')) { clear(); }
})();

/* ============================================================
   Buy cart (real Shopify cart at /cart) — AJAX quantity + remove
   with live totals, keyed by line item key so removals don't shift
   other lines. Independent of the localStorage quote lane above.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-buy-cart]');
  if (!root) return;
  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function change(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('#BuyCartCount, [data-buy-count]').forEach(function (e) { e.textContent = cart.item_count; });
      if (cart.item_count === 0) { window.location.reload(); return; }
      root.querySelectorAll('[data-buy-subtotal]').forEach(function (e) { e.textContent = money(cart.total_price); });
      var byKey = {}; cart.items.forEach(function (it) { byKey[it.key] = it; });
      root.querySelectorAll('.cart-row[data-buy-key]').forEach(function (row) {
        var it = byKey[row.getAttribute('data-buy-key')];
        if (!it) { if (row.parentNode) { row.parentNode.removeChild(row); } return; }
        var lt = row.querySelector('[data-buy-line-total]'); if (lt) { lt.textContent = money(it.final_line_price); }
        var inp = row.querySelector('[data-buy-input]'); if (inp) { inp.value = it.quantity; }
      });
    }).catch(function () { window.location.reload(); });
  }
  root.addEventListener('click', function (e) {
    var row = e.target.closest ? e.target.closest('.cart-row[data-buy-key]') : null; if (!row) return;
    var key = row.getAttribute('data-buy-key'), inp = row.querySelector('[data-buy-input]'), cur = inp ? (parseInt(inp.value, 10) || 1) : 1;
    if (e.target.closest('[data-buy-remove]')) { e.preventDefault(); change(key, 0); }
    else if (e.target.closest('[data-buy-up]')) { change(key, cur + 1); }
    else if (e.target.closest('[data-buy-down]')) { change(key, Math.max(0, cur - 1)); }
  });
  root.addEventListener('change', function (e) {
    var inp = e.target.closest ? e.target.closest('.cart-row[data-buy-key] [data-buy-input]') : null; if (!inp) return;
    change(inp.closest('.cart-row[data-buy-key]').getAttribute('data-buy-key'), Math.max(0, parseInt(inp.value, 10) || 0));
  });
})();

/* Mobile header — hamburger toggles the nav drawer (≤760px). */
(function () {
  var bar = document.querySelector('.topbar');
  var burger = bar && bar.querySelector('.topbar-burger');
  if (!bar || !burger) return;
  function close() { bar.classList.remove('nav-open'); burger.setAttribute('aria-expanded', 'false'); }
  burger.addEventListener('click', function () {
    var open = bar.classList.toggle('nav-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  // Close when a drawer link is tapped (the link still navigates).
  bar.addEventListener('click', function (e) {
    if (bar.classList.contains('nav-open') && e.target.closest('.topbar-nav a')) close();
  });
  // Close on Escape.
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

/* Inventory filter "+ More …" dropdowns — jump to the chosen filter URL (mockup style). */
(function () {
  var bar = document.querySelector('.filterbar');
  if (!bar) return;
  bar.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('select.chip-dropdown[data-filter-more]') : null;
    if (sel && sel.value) window.location.href = sel.value;
  });
})();

/* Search: AND-join loose terms so a multi-word query narrows instead of widens.
   Shopify's storefront search ORs terms by default, so "hardware cloth" matched
   854 of 878 products — effectively the whole catalogue, with gopher baskets
   ranked above any actual hardware cloth. Joining the terms with AND returns 9.
   Applies to every search form (header, search page, collection, 404). Left
   untouched if the shopper already used quotes, a boolean, or a - exclusion. */
(function () {
  var ADVANCED = /["'*]|(^|\s)(AND|OR|NOT)(\s|$)|(^|\s)-\S/;

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('form[action*="/search"]') : null;
    if (!form) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    var raw = (input.value || '').trim();
    if (!raw || ADVANCED.test(raw)) return;

    var parts = raw.split(/\s+/).filter(Boolean);
    if (parts.length < 2) return;

    /* Navigate manually rather than mutating the visible input, so the shopper
       never sees "hardware AND cloth" flash into the box they just typed in. */
    e.preventDefault();
    var action = form.getAttribute('action') || '/search';
    var params;
    try {
      var fd = new FormData(form);
      fd.set('q', parts.join(' AND '));
      params = new URLSearchParams(fd).toString();
    } catch (x) {
      params = 'q=' + encodeURIComponent(parts.join(' AND ')) + '&type=product';
    }
    window.location.href = action + '?' + params;
  });
})();

/* ============================================================
   Meshy chat links. The widget is served from the Railway bot and still
   points its quick links at the old howard-wire-cloth-co.myshopify.com
   address, with "Request a Quote" going to Contact. The fix is committed
   in howard-wire-bot but not deployed, so correct the links here at click
   time. Harmless once the widget itself is redeployed.
   ============================================================ */
(function () {
  'use strict';
  var OLD = 'howard-wire-cloth-co.myshopify.com';
  var QUICK = { '/pages/contact': '/pages/quote', '/collections/all': '/collections', '/pages/faq-1': '/pages/wire-mesh-faq' };
  function fix(a) {
    var u;
    try { u = new URL(a.getAttribute('href')); } catch (e) { return; }
    if (u.hostname !== OLD) { return; }
    var path = u.pathname.replace(/\/$/, '') || '/';
    /* Contact → Quote only for the chat's "Request a Quote" shortcut; a contact
       link inside a chat answer should still go to Contact. */
    if (QUICK[path] && (path !== '/pages/contact' || a.classList.contains('hw-qa-item'))) { path = QUICK[path]; }
    a.setAttribute('href', path + u.search + u.hash);
  }
  function onPoint(e) {
    var a = e.target.closest ? e.target.closest('a[href*="' + OLD + '"]') : null;
    if (a) { fix(a); }
  }
  /* capture phase, and on hover/focus too, so the status bar shows the right address */
  ['click', 'auxclick', 'mouseover', 'focusin', 'touchstart'].forEach(function (t) {
    document.addEventListener(t, onPoint, true);
  });
})();
